import { CartAddressPage } from "./CartAddressPage";

export default CartAddressPage;